'use client';

import { Link, useMatchRoute } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/components/ui/sidebar';
import { useConfig } from '@/hooks/use-config';
import { cn } from '@/lib/utils';

export const NavMain = () => {
  const { mainNav } = useConfig();
  const matchRoute = useMatchRoute();

  return (
    <SidebarGroup>
      <SidebarMenu>
        {mainNav.map((item) => (
          <Collapsible
            key={item.title}
            asChild
            defaultOpen={!!matchRoute({ to: item.href.href, fuzzy: false })}>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                tooltip={item.title}>
                <Link to={item.href.href}>
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
              {item.items.length ? (
                <>
                  <CollapsibleTrigger asChild>
                    <SidebarMenuAction className='data-[state=open]:rotate-90'>
                      <ChevronRight />
                      <span className='sr-only'>Toggle</span>
                    </SidebarMenuAction>
                  </CollapsibleTrigger>
                  <CollapsibleContent>
                    <SidebarMenuSub>
                      {item.items.map((subItem) => (
                        <SidebarMenuSubItem key={subItem.title}>
                          <SidebarMenuSubButton
                            asChild
                            className={cn(
                              matchRoute({
                                to: subItem.href.href,
                                fuzzy: false,
                              }) &&
                                'bg-sidebar-accent text-sidebar-accent-foreground font-semibold'
                            )}>
                            <Link to={subItem.href.href}>
                              <span>{subItem.title}</span>
                            </Link>
                          </SidebarMenuSubButton>
                        </SidebarMenuSubItem>
                      ))}
                    </SidebarMenuSub>
                  </CollapsibleContent>
                </>
              ) : null}
            </SidebarMenuItem>
          </Collapsible>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
};
